import providerAppServices from '../../../services/provider/application'
import _ from 'lodash'

import Infos from '../../share/application-setting/Infos'
import Domains from '../../share/application-setting//Domains'
import Settings from '../../share/application-setting//Settings'
import Acknowledgment from '../../share/application-setting//Acknowledgment'
import Completion from '../../share/application-setting//Completion'
import Aggrement from '../../share/application-setting//Aggrement'
import ConfigureDueDate from '../../share/application-setting//ConfigureDueDate'

export default {
    components: {
        Infos,
        Domains,
        Settings,
        Acknowledgment,
        Completion,
        Aggrement,
        ConfigureDueDate
    },
    data() {
        return {
            item: {},
            initialItem: {},
            key: 0,
            mountedKey: 0,
            services: providerAppServices,
            hasUnsavedChanges: false,
            showPopup: false,
            nextRoute: null,
        }
    },
    created(){
        this.getProfile(false)
        if(localStorage.getItem('updatecompleted')=='Y')
        {
            this._showToast('Update Completed!')
            localStorage.removeItem('updatecompleted')
        }
    },
    computed: {
        clonedObjectA() {
            return JSON.parse(JSON.stringify(this.initialItem))
        },
    },
    mounted() {
        window.__organizationComponent = this
    },
    beforeDestroy() {
        if (window.__organizationComponent === this) {
            delete window.__organizationComponent
        }
    },
    methods: {
        getProfile(showToast) {
            this.services.getProfile().then(resp => {
                if (!resp.error) {
                    // Create deep copies to avoid reference issues
                    this.initialItem = _.cloneDeep(resp.data.d)
                    this.key += 1
                    this.$nextTick(() => {
                        this.item = resp.data.d
                        this.$store.state.organization.is_centralized_setting_enabled = resp.data.d?.centralizedintake?.is_setting_enabled
                        this.mountedKey += 1
                    })
                    if(showToast)
                    {
                        localStorage.setItem('updatecompleted','Y')
                        window.location.reload(true)
                    }
                }
            })
        },
        onCompleted() {
            this.getProfile(false)
        },
        async save(showToast) {
            try {
                await this.$nextTick()
                if (this.$refs.Infos && this.$refs.Infos.save) {
                    await this.$refs.Infos.save()
                }
                if (this.$refs.Domains && this.$refs.Domains.save) {
                    await this.$refs.Domains.save()
                }
                if (this.$refs.Settings) {
                    if (this.$refs.Settings.save) await this.$refs.Settings.save()
                    if (this.$refs.Settings.updateCentralizedSetting) await this.$refs.Settings.updateCentralizedSetting()
                    if (this.$refs.Settings.saveCentralizedSetting) await this.$refs.Settings.saveCentralizedSetting()
                    if (this.$refs.Settings.saveRegistrationSetting) await this.$refs.Settings.saveRegistrationSetting()
                }
                // Skip Acknowledgment and Completion since they are commented out in template
                // if (this.$refs.Acknowledgment && this.$refs.Acknowledgment.save) {
                //     await this.$refs.Acknowledgment.save()
                // }
                // if (this.$refs.Completion && this.$refs.Completion.save) {
                //     await this.$refs.Completion.save()
                // }
                if (this.$refs.ConfigureDueDate && this.$refs.ConfigureDueDate.save) {
                    console.log('Calling ConfigureDueDate.save()')
                    await this.$refs.ConfigureDueDate.save()
                } else {
                    console.warn('ConfigureDueDate ref or save method not available:', {
                        ref: !!this.$refs.ConfigureDueDate,
                        saveMethod: this.$refs.ConfigureDueDate ? !!this.$refs.ConfigureDueDate.save : false
                    })
                }
                this.getProfile(true)
                if (showToast && this.nextRoute) {
                    this.$router.push(this.nextRoute)
                }
            } catch (error) {
                console.error('Error saving organization settings:', error)
                this._showToast('Error saving settings. Please try again.', { variant: 'danger' })
            }
        },
        leavePage() {
            this.$router.push(this.nextRoute)
        },
        cancel() {
            this.getProfile(false)
        },
        compareObjects(obj1, obj2) {
            return JSON.stringify(obj1) !== JSON.stringify(obj2)
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.hasUnsavedChanges) {
            this.showPopup = true
            this._showConfirm('Are you sure you want to leave this page?<br/>Changes you made will not be saved.', { title: 'Unsaved Changes', variant: 'warning' ,saveLabel: 'Save'}).then(confirm => {
                if (confirm) {
                    this.save(true).then(() => next())
                }
                else
                {
                    this.leavePage()
                    next()
                }
            })
        } else {
            next()
        }
    }
}